import axios from "axios";
import { API_URLS } from "../../config";

function uploadMedia(formData, language) {
  return axios.post(`${API_URLS.BLOB_STORAGE.UPLOAD_ATTACHMENT}?language_code=${language}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export { uploadMedia };
